import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ParkingCredentialsNew from "./ParkingCredentialsNew";
import { parkingCredentialsService } from "../../../services/parkingCredentialsService";
import Loading from "../../../components/Loading/Loading";
import { useCustomToast } from "../../../components/CustomToast/CustomToast";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../../constants/routes-path";

const ParkingCredentialsEdit = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const [initialData, setInitialData] = useState(null);
    const [loading, setLoading] = useState(true);
    const toast = useCustomToast();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await parkingCredentialsService.find(id);
                setInitialData(data);
                setLoading(false);
            } catch (err) {
                toast({ title: t("parking-credentials.messages.errors.find"), status: "error" });
                redirectToList();
            } finally {
                setLoading(false);
            }
        };

        if (id) fetchData();
    }, [id, toast, navigate]);

    const handleUpdate = async (dto) => {
        try {
            await parkingCredentialsService.update(id, dto);
            toast({ title: t("parking-credentials.messages.success.update"), status: "success" });
            redirectToList();
        } catch (err) {
            toast({ title: t("parking-credentials.messages.errors.update"), status: "error" });
        }
    };

    const redirectToList = () => {
        navigate(ROUTES.transportManagementPath + ROUTES.parkingCredentials);
    };

    return <ParkingCredentialsNew initialData={initialData} onSubmit={handleUpdate} isEdit loading={loading} id= {id} />;
};

export default ParkingCredentialsEdit;
